export default {"src":"/_next/static/media/icon-goodness.00030041.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};